module.exports = __webpack_public_path__ + "img/sce2.b2dafdf8.png";